import { FormGridField } from "../../components/FormGrid";

export interface TextInputDefinition {
    name: string;
    id: string;
    placeholder: string;
    label: string;
    schemaName: string;
    fieldOverrides?: any;
    disabled?: boolean;
    buildFormGridField: (schema) => FormGridField;
}

export default function buildTextInputDefinition({
    name,
    id,
    placeholder,
    label,
    schemaName,
    fieldOverrides,
    disabled
}: {
    name: string;
    id: string;
    placeholder: string;
    label: string;
    schemaName: string;
    fieldOverrides?: any;
    disabled?: boolean;
}): TextInputDefinition {
    return {
        name,
        id,
        placeholder,
        label,
        schemaName,
        fieldOverrides,
        disabled,
        buildFormGridField: _createTextInputField
    };
}

function _createTextInputField(schema): FormGridField {
    const {
        name,
        id,
        label,
        placeholder,
        schemaName,
        fieldOverrides,
        disabled
    } = this;

    return {
        name,
        fieldType: "input",
        fieldOptions: {
            id,
            placeholder,
            inputType: "text",
            label,
            disabled
        },
        validationSchema: {
            ...schema.properties[schemaName],
            required: schema.hasOwnProperty("required")
                ? schema.required.includes(name)
                : false
        },
        columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6",
        formSpacing: true,
        ...fieldOverrides
    };
}
